export default __webpack_public_path__ + "static/media/wallet-connect.03da5e3f.svg";